<template>
    <v-content>
        <v-container fluid>
            <v-row style="height: 40px;">
    
            </v-row>
        </v-container>
    
        <v-container fluid>
            <v-row align="start" justify="center">
                <v-col cols="12" sm="6" md="6" xl="4">
                    <v-card class="elevation-12">
                        <!-- <v-toolbar dark flat>
                                <v-spacer />
                                <v-toolbar-title>{{ $t('forgot.title') }}</v-toolbar-title>
                                <v-spacer />
                            </v-toolbar> -->
    
                        <v-container fluid>
                            <v-row style="height: 40px;" align="center" justify="center" class="mt-5">
                                <p class="main-title"> {{ $t('forgot.title') }} </p>
                            </v-row>

                            <v-row style="height: 20px;" align="center" justify="center">
                                <p class="sub-title"> {{ $t('forgot.sub_title') }} </p>
                            </v-row>
                        </v-container>
    
                        <v-card-text class="px-10">
                            <v-form ref="form">
                                <v-text-field v-model="email" :rules="emailRules" v-bind:label="$t('forgot.email')" outlined name="email" prepend-icon="person" type="text" required/>
                            </v-form>
                        </v-card-text>
    
                        <v-container class="px-12" fluid>
                            <v-row align="center" justify="center">
                                <v-col cols="12" sm="8" md="8">
                                    <v-btn large block color="primary"  class="normal-button" @click="sendEmail">{{ $t('forgot.send') }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
    data: () => ({
        valid: true,
        email: '',
        emailRules: [
            v => !!v || i18n.t('validate.email_require'),
            v => /.+@.+\..+/.test(v) || i18n.t('validate.email_invalid'),
        ],
    }),

    methods: {
        sendEmail: async function() {
            const self = this;
            const requestBody = {
                email: self.email
            };
            try {
                //TODO use dotenv with Vue to load app config from file such as below url

                const response =  await this.$http.post(process.env.VUE_APP_FORGOT_URL, requestBody);
                if(response.data && response.data.success) {
                    this.$fire({
                        title: i18n.t('forgot.request_success'),
                        text: i18n.t('forgot.check_email'),
                        type: "success"
                        }).then(() => {
                            this.$router.push('/');
                    });
                } else if(!response.data.success) {
                    alert(i18n.t(response.data.message));
                } else {
                    alert(i18n.t('validate.request_error'));
                }  
            } catch(e) {
                console.log(e.stack);
                // dùng vue alert //alert(e.message);
                alert(i18n.t('validate.request_error'));
            }
        },
    }
}
</script>

<style scoped>
.main-title {
    color: #1D243E;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
}

.sub-title {
    color: #1D243E;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
}

.normal-button {
    font-size: 16px;
    font-style: normal;
    font-weight: bold;
}
</style>